export default __webpack_public_path__ + "static/media/BAD19-400x482.839c314e.jpg";